













import VueOptions from '@utils/VueOptions'

settings =
  name: 'FormFieldNumber'

  vue:
    props: ['value', 'errors', 'placeholder']

    data: ->
      v = @value
      v = undefined if v is null
      value_: v

    methods:
      hiInputChange: (value) ->
        @$emit 'input', value

    watch:
      value: (v) ->
        @value_ = v

export default VueOptions.vue settings
